import colorTheme from 'constants/color';
import cashierActions from 'features/cashier/services/actions';
import { FEATURE_PRODUCT_MODE } from 'features/cashier/services/constants';
import cashierSelectors from 'features/cashier/services/selectors';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import CardTicketItem from '../CardTicketItem';

const PACKAGE_TAB_COLOR = '#EBA33B';
// màu đã chốt: inactive nền trắng + icon #EBA33B; active nền #EBA33B + icon trắng
const PACKAGE_TAB_INACTIVE_BG = '#FFFFFF';

type Props = {
  v2?: boolean;
};

// Tab Packages ở header cashier: chỉ hiện khi shop bật displayPackageService, bấm để panel giữa hiện danh sách package
const Package = ({ v2 }: Props) => {
  const dispatch = useAppDispatch();
  const displayPackageService = shopSelectors.data.displayPackageService();
  const featureProductMode = cashierSelectors.getFeatureProductMode();

  if (!displayPackageService) return null;

  const active = featureProductMode === FEATURE_PRODUCT_MODE.PACKAGE;
  const icon = active ? 'cardPackageV2Active' : 'cardPackageV2';
  const setFeaturePackage = () => {
    dispatch(cashierActions.setFeatureProductMode(FEATURE_PRODUCT_MODE.PACKAGE));
  };

  if (v2)
    return (
      <CardTicketItem
        icon={icon}
        content={'Packages'}
        v2
        nbgcolor={PACKAGE_TAB_COLOR}
        border_color={PACKAGE_TAB_COLOR}
        border_color2={PACKAGE_TAB_COLOR}
        active={active}
        onClick={setFeaturePackage}
      />
    );

  return (
    <CardTicketItem
      icon={icon}
      content={'Packages'}
      nbgcolor={PACKAGE_TAB_INACTIVE_BG}
      textColor={colorTheme.text_3}
      border_color={PACKAGE_TAB_COLOR}
      active={active}
      onClick={setFeaturePackage}
    />
  );
};

export default Package;
